import towait_mo from "../../../assets/images/towait_mo.webp";
import towait_pc from "../../../assets/images/towait_pc.webp";
import rec_mo from "../../../assets/images/rec_mo.webp";
import rec_pc from "../../../assets/images/rec_pc.webp";
import checkp from "../../../assets/images/checkp.svg";

export default function Towards() {
  return (
    <div
      className="w-full bg-[#E4F7FF] lg:px-[120px] lg:mt-6 bg-center bg-cover bg-no-repeat mt-10"
      style={{
        backgroundImage: `url(${
          window.innerWidth < 768 ? towait_mo : towait_pc
        })`,
      }}
    >
      <div className="container mx-auto p-3 flex flex-col gap-4 lg:flex-row lg:w-full lg:items-center lg:gap-2">
        <div className="flex flex-col gap-4 w-full lg:w-1/2">
          <div className="flex items-center gap-2">
            <p className="text-[#333333] text-[18px] font-semibold">
              Giá trị đội ngũ hướng tới
            </p>
            <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
              <p className="text-[1.125rem] font-semibold text-white">
                BlueSkyIT
              </p>
            </div>
          </div>
          <div>
            <p className="text-[28px] lg:text-[36px] text-[#1375B7] font-semibold">
              Sức mạnh của sự hợp tác
            </p>
          </div>
          <div className="w-full h-[14rem] lg:h-[140px] px-[24px] py-[16px] flex gap-2 rounded-[6px] bg-white border border-solid border-[#B7E7FF] ">
            <div className="w-11 h-11 bg-[#E4F7FF] rounded-[6px] flex items-center justify-center">
              <img src={checkp} alt="sm" />
            </div>
            <p className="w-[260px] lg:w-full">
              BlueSkyIT tin rằng thành công của chúng tôi đến từ sự gắn kết và
              hợp tác hiệu quả của toàn đội ngũ. Mỗi cá nhân đều góp phần xây
              dựng một môi trường làm việc sáng tạo, năng động và cùng nhau tạo
              nên các giải pháp công nghệ tiên phong
            </p>
          </div>
        </div>
        <div className="w-full lg:w-1/2">
          <img
            src={rec_mo}
            alt="cm"
            className="block md:hidden lg:hidden w-full h-auto object-contain"
          />
          <img
            src={rec_pc}
            alt="cm1"
            className="hidden md:block lg:block w-full
           object-contain"
          />
        </div>
      </div>
    </div>
  );
}
